import { type FC } from 'react';
import { useSelector } from 'react-redux';

import { getFilterLocation } from 'shared/selectors/filters/getFilterLocation';
import { seriaPlusByLocation } from 'shared/settings/seriaPlusScheme';

import { SeriaPlus } from './SeriaPlus';

export const SeriaPlusContainer: FC = () => {
  const location = useSelector(getFilterLocation);

  return location in seriaPlusByLocation ? <SeriaPlus scheme={seriaPlusByLocation[location]} /> : null;
};
